import * as React from "react";
import { cx } from "../util.js";

export type CodexType = "character" | "location" | "object" | "lore" | "subplot" | "other";

const TYPE_VAR: Record<CodexType, string> = {
  character: "var(--bw-type-character)",
  location: "var(--bw-type-location)",
  object: "var(--bw-type-object)",
  lore: "var(--bw-type-lore)",
  subplot: "var(--bw-type-subplot)",
  other: "var(--bw-type-other)",
};

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Optional codex type — renders a leading dot in the type color. */
  type?: CodexType;
  /** Custom dot color (overrides `type`). */
  dotColor?: string;
}
/** Sunken pill used for codex entries (POV, characters, locations) with a type dot. */
export function Chip({ type, dotColor, className, children, ...rest }: ChipProps) {
  const color = dotColor ?? (type ? TYPE_VAR[type] : undefined);
  return (
    <span className={cx("ip-chip", className)} {...rest}>
      {color && <span className="ip-dot" style={{ background: color }} aria-hidden />}
      {children}
    </span>
  );
}

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {}
/** Accent-tinted tag for scene tags / keywords. */
export function Tag({ className, ...rest }: TagProps) {
  return <span className={cx("ip-tag", className)} {...rest} />;
}

/** The canonical color for a codex entry type (for dots, charts, highlights). */
export function codexTypeColor(type: CodexType): string {
  return TYPE_VAR[type];
}
